import Vue from 'vue';
import store from '@/Plugins/Store';
import '@/Plugins/Store/Ui';

import i18n from '@/Plugins/I18n';
import '@/Plugins/Meta';

import '@/Plugins/Offline';
import '@/Plugins/Filters';
import '@/Theme/Styles/styles.scss';

import App from '@/Layouts/App.vue';
import '@/registerServiceWorker';

import '@/Plugins/ApplicationInsights';

Vue.config.productionTip = false;

new Vue({
  i18n,
  store,
  render: h => h(App),
}).$mount('#app');
